import { createSlice } from '@reduxjs/toolkit';

const issueSlice = createSlice({
  name: 'issue',
  initialState: {
    issues: [],
    loading: false,
    error: null
  },
  reducers: {}
});

export default issueSlice.reducer;